<template>
    <g class="arm500">
      <g class="armfront" data-name="armfront">
        <polygon class="innertop topside" data-name="innertop topside" points="1337.58 2828.47 1302.93 2808.47 1302.93 2768.47 1337.58 2788.47 1337.58 2828.47" fill="#5070af"/>
        <polygon class="innerright rightside" data-name="innerright rightside" points="1302.93 2768.47 1302.93 2808.47 1337.58 2788.47 1302.93 2768.47" fill="#365593"/>
      </g>
      <g class="armholder" data-name="armholder">
        <polygon class="armholder-front" data-name="armholder-front" points="1779.69 2615.72 1727.73 2585.72 1727.73 2465.72 1779.69 2495.72 1779.69 2615.72" fill="#7793bf"/>
        <polygon class="armholder-right" data-name="armholder-right-10px" points="1788.36 2610.72 1779.7 2615.72 1779.7 2495.72 1788.36 2490.72 1788.36 2610.72" fill="#3d6199"/>
      </g>
      <polygon class="rightarm500" points="1770.59 2578.47 1337.58 2828.47 1337.58 2788.47 1770.59 2538.47 1770.59 2578.47" fill="#365593"/>
      <polygon class="toparm top" data-name="toparm top" points="1770.59 2538.47 1337.58 2788.47 1302.93 2768.47 1735.95 2518.47 1770.59 2538.47" fill="#5070af"/>
      <g class="double-arm500" v-if="doubleBranch">
        <polygon class="armholder-right" data-name="armholder-right-10px" points="1814.33 2595.44 1805.67 2600.44 1805.67 2480.44 1814.33 2475.44 1814.33 2595.44" fill="#3d6199"/>
        <polygon class="darm500 rightside" data-name="darm500 rightside" points="1814.35 2553.2 2238.24 2308.47 2238.24 2268.47 1814.33 2513.22 1814.35 2553.2" fill="#365593"/>
        <polygon class="darm500 frontside" data-name="darm500 frontside" points="1814.33 2513.22 1814.34 2473.21 2203.6 2248.47 2238.24 2268.47 1814.33 2513.22" fill="#5070af"/>
      </g>
    </g>
</template>
<script>
export default {
  props: {
    doubleBranch: Boolean,
  },

  name: "Arm500-B.vue",
};
</script>